/**
 * Interface for table header component
 */
export enum HeaderButtonType {
  EDIT = 'edit',
  DELETE = 'delete',
}
